<template>
  <div class="background">
    <!-- <div id="overlay" v-if="videoOverlayVisible">
      <video id="fullscreenVideo" style="width:100%" autoplay>
        <source :src="infoVideoPath" type="video/mp4" />
      </video>
    </div>
    <div id="overlay" style="height:100%" v-else-if="imageOverlayVisible">
      <img height="100%" :src="infoImagePath" />
    </div>-->
    <vueper-slides
      ref="slideShow"
      :infinite="false"
      :bullets="false"
      disable-arrows-on-edges
      fixedHeight="100%"
      class="no-shadow"
      @ready="slideInit($event)"
      @slide="slideChanged($event)"
    >
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :content="slide"
      ></vueper-slide>
    </vueper-slides>

    <div id="overlayBottomRight">
      <img
        src="@/assets/ZURUECK.png"
        style="width: 7%"
        alt="Back Button"
        @click="backClicked()"
      />
    </div>
    <div id="overlayBottomRightInfo" style="z-index: 100" v-if="infoExists">
      <img
        src="@/assets/button-information.png"
        style="width: 3%"
        alt="Info Button"
        @click="showInfo()"
      />
    </div>
    <div
      id="overlayBottomRightVideo"
      style="z-index: 100"
      v-if="infoVideoExists"
    >
      <img
        src="@/assets/button-video_kamera.png"
        style="width: 3%"
        alt="Video Button"
        @click="showInfoVideo()"
      />
    </div>
  </div>
</template>

<script>
import { slideSettings } from "../SlideSettings";

import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "Slides",
  components: { VueperSlides, VueperSlide },
  data() {
    return {
      slides: [],
      backDestinationName:
        slideSettings[this.$route.params.page].backDestinationName,
      backDestinationParam:
        slideSettings[this.$route.params.page].backDestinationParam,

      globalInfoVideoPath: slideSettings[this.$route.params.page].infoVideo,
      // videoOverlayVisible: false,
      globalInfoImagePath: slideSettings[this.$route.params.page].infoImage,
      // imageOverlayVisible: false,

      currentSlideIndex: 0,
    };
  },
  computed: {
    infoExists() {
      return (
        this.globalInfoImagePath ||
        slideSettings[this.$route.params.page].slides[this.currentSlideIndex]
          .infoImage
      );
    },
    infoVideoExists() {
      return (
        this.globalInfoVideoPath ||
        slideSettings[this.$route.params.page].slides[this.currentSlideIndex]
          .infoVideo
      );
    },
  },
  methods: {
    backClicked() {
      this.$router.push({
        name: this.backDestinationName,
        params: { page: this.backDestinationParam },
      });
    },
    slideChanged(params) {
      this.currentSlideIndex = params.currentSlide.index;
      // const that = this;

      // setTimeout(function () {
      //   that.$refs.slideShow.goToSlide(1, { animation: false });
      // }, 1000);
    },
    slideInit(params) {
      // console.log("slide init");
      // this.$refs.slideShow.goToSlide(this.$route.params.slideindex, {
      // this.$refs.slideShow.goToSlide(1, {
      //   animation: false,
      // });
      this.slideChanged(params);
    },
    showInfo() {
      if (this.globalInfoImagePath) {
        this.$router.push({
          name: "slidepage",
          params: { page: this.globalInfoImagePath },
        });
      } else if (
        slideSettings[this.$route.params.page].slides[this.currentSlideIndex]
          .infoImage
      ) {
        this.$router.push({
          name: "slidepage",
          params: {
            page:
              slideSettings[this.$route.params.page].slides[
                this.currentSlideIndex
              ].infoImage,
          },
        });
      }
      // console.log(this.$refs.slideShow.currentSlide.index);
      // console.log(this.$event.currentSlide.index);
      //   this.$router.push({
      //     name: "slidepage",
      //     params: { page: this.info }
      //   });
      // if (this.infoVideoPath) {
      //   this.videoOverlayVisible = !this.videoOverlayVisible;
      // } else if (this.infoImagePath) {
      //   this.imageOverlayVisible = !this.imageOverlayVisible;
      // }
    },
    showInfoVideo() {
      // this.videoOverlayVisible = !this.videoOverlayVisible;

      if (this.globalInfoVideoPath) {
        this.$router.push({
          name: "videostartpage",
          params: { page: this.globalInfoVideoPath },
        });
      } else if (
        slideSettings[this.$route.params.page].slides[this.currentSlideIndex]
          .infoVideo
      ) {
        this.$router.push({
          name: "videostartpage",
          params: {
            page:
              slideSettings[this.$route.params.page].slides[
                this.currentSlideIndex
              ].infoVideo,
          },
        });
      }
    },
    createImageEntry(path) {
      return `<img src='${path}' style='height:100%; width: 100%'></img>`;
    },
    // createVideoEntry(path) {
    //   return `
    //         <div style="width:90%">
    //           <video id="fullscreenVideo" style="width:100%; object-fit: fill;" muted controls>
    //               <source src='${path}' type="video/mp4"></source>
    //           </video>
    //         </div>
    //         `;
    // }
    // createVideoEntry(path) {
    //   return `
    //       <div style="width:90%">
    //             <video class="videoInsert" style="width:100%" muted controls>
    //                 <source src='${path}' type="video/mp4"></source>
    //             </video>
    //       </div>
    //         `;
    // }
    showSlides(page) {
      this.slides = [];
      slideSettings[page].slides.forEach((element) => {
        const copy = { ...element };

        // if (process.env.NODE_ENV === "development") {
        if (
          !copy.path.startsWith("https://") &&
          !copy.path.startsWith("http://")
        ) {
          copy.path = "https://my.lrinfomanager.com/" + copy.path;
        }
        if (copy.type === "image") {
          this.slides.push(this.createImageEntry(copy.path));
        }
      });
    },
    moveSlide(index) {
      const that = this;

      setTimeout(function () {
        // this.$refs.slideShow.goToSlide(this.$route.params.slideindex, {
        that.$refs.slideShow.goToSlide(index, {
          animation: false,
        });
      }, 100);
    },
  },
  created() {
    this.showSlides(this.$route.params.page);

    this.moveSlide(0);

    // if (
    //   this.globalInfoImagePath &&
    //   !this.globalInfoImagePath.startsWith("https://") &&
    //   !this.globalInfoImagePath.startsWith("http://")
    // ) {
    //   this.globalInfoImagePath =
    //     "https://my.lrinfomanager.com/" + this.globalInfoImagePath;
    // }

    // setTimeout(function() {
    //   that.$refs.slideShow.goToSlide(1, { animation: false });
    // }, 100);
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.slideShow.goToSlide(this.$route.params.slideindex, {
    //     animation: false,
    //   });
    // });
  },
  beforeRouteUpdate: function (to, from, next) {
    // this.backgroundSettings.backgroundImage =
    //   menuSettings.pageSettings[to.params.page].backgroundImage;
    // this.tiles = menuSettings.pageSettings[to.params.page].tiles;
    this.backDestinationName =
      slideSettings[to.params.page].backDestinationName;
    this.backDestinationParam =
      slideSettings[to.params.page].backDestinationParam;
    this.globalInfoVideoPath = slideSettings[to.params.page].infoVideo;
    this.globalInfoImagePath = slideSettings[to.params.page].infoImage;

    this.showSlides(to.params.page);

    this.moveSlide(0);
    this.currentSlideIndex = 0;

    next();
  },
};
</script>

<style>
/* Modifications for fullscreen slides for vueper */
/* .vueperslides__parallax-wrapper {
  height: 100%;
}

.vueperslide__content-wrapper {
  width: 100%;
  height: 100%;
} */
.vueperslides__arrow {
  color: green;
}
</style>

<style scoped>
.background {
  width: 100%;
  height: 100%;
}

#overlayBottomRight {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
  z-index: 99;
}

.videoInsert {
  position: absolute;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  background-size: cover;
  overflow: hidden;
}

#overlayBottomRightInfo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 90%;
  /* padding: 30px; */
  text-align: right;
}

#overlayBottomRightVideo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 86.5%;
  /* padding: 30px; */
  text-align: right;
}
</style>